import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import Comparison from '../../../../prototypes/Comparison';
import layout from './Jobs.json';
import JobDialog from './JobDialog.js'
import EtelAPI from '../../../../api/EtelAPI.js';
import Alerts from '../../../../prototypes/Alerts.js';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import moment from 'moment';

class JobsList extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      row: this.props.row === undefined ? {} : this.props.row,
      showDialog: false,
      dialogMode: 'EDIT'
    };

    this.onIconClicked = this.onIconClicked.bind( this );
    this.onClose = this.onClose.bind( this );
    this.onSave = this.onSave.bind( this );
    this.onClickNewItem = this.onClickNewItem.bind( this );
  }

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;
    if( props.row !== undefined ) {
      const compare = new Comparison( props.row, state.row );
      if( compare.isMatch(compare.MatchTypes.DataRow) === false ) {
        newState.row = props.row;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  // Handles exceptions
  onHandleException( e ) {
    const title = 'Jobs';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
      this.doLogOff();
    // This only needs to warn the user
    } else if( status === 400 ) {
      alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      alerts.CRITICAL( title, e );
    }
  }
  
  // Returns user back to the login page if creds fail
  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }
  
  onIconClicked( args ) { 
    this.setState( {
      row: args.row,
      showDialog: true
    } );
  }

  onClose( e ) { 
    this.setState( {
      showDialog: false
    } );
  }

  onSave( e ) { 
    let { dispatch, bugsnag } = this.props;
    let alert = new Alerts( bugsnag, dispatch );
    let api = new EtelAPI('jobs');
    let row = e.target.row;
    row.NEXT_RUNTIME = moment(row.START_DATE).format('YYYY-MM-DD HH:mm:ss');
    let payload = {}
    let newItem = layout.section.newitem;
    let newItemKeys = Object.keys( newItem );
    let rowKeys = Object.keys( row );

    for( let keyIndex = 0; keyIndex < rowKeys.length; keyIndex++ ) {
      const rowKey = rowKeys[ keyIndex ];
      if( newItemKeys.includes(rowKey) === true ) {
        payload[ rowKey ] = row[ rowKey ];
      }
    }

    if( payload.JOB_ID === 0 ) {
      api.insert( payload ).then( ( result ) => { 
          this.setState( { 
            row: result.data[0]
          } );
        } ).catch( ( exception ) => { 
          this.onHandleException( exception );
      }, ( ) => { 
        alert.SUCCESS("New Job","Successfully saved the new job.", 2500 );
      } );
    } else {
      api.update( payload ).then( ( result ) => { 
        this.setState( { 
          row: result.data[0]
        }, () => { 
          alert.SUCCESS("Update Job","Successfully updated the job.", 2500 );
        } );
      } ).catch( ( exception ) => { 
        this.onHandleException( exception );
      } );
    }
    this.setState( { 
      showDialog: false
    } );
  }

  onClickNewItem( ) {
    let newItem = layout.section.newitem;
    newItem.START_DATE = moment().format("YYYY-MM-DD HH:mm:ss");
    newItem.END_DATE = "2099-12-31 12:59:59"
    this.setState( {
      row: layout.section.newitem, 
      showDialog: true,
      dialogMode: 'NEW'
    } );
  }

  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations']}>
        <ListContainer
          id="JobsList"
          layout={layout}
          row={this.state.row}
          onIconClicked={this.onIconClicked}
          onNewItem={this.onClickNewItem}
          selectedtab={1}
        />
      <JobDialog 
        mode={this.state.dialogMode}
        show={this.state.showDialog} 
        onClose={this.onClose}
        onSave={this.onSave}
        row={this.state.row}
      />        
      </PageAuthorize>
    );
  }
}

// Exports
export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( JobsList ) 
);



// WEBPACK FOOTER //
// ./src/content/technical/jobs/components/JobsList.js